"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _commonReact = require("@devsta/common-react");

var _ListStoryboards = _interopRequireDefault(require("../components/ListStoryboards"));

var _api = require("../api");

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

function ListStoryboards(_ref) {
  var history = _ref.history;
  return _react.default.createElement(_commonReact.AuthorisationConsumer, {
    requiresOrganisation: true
  }, function (_ref2) {
    var _ref2$selectedOrganis = _ref2.selectedOrganisation,
        organisationId = _ref2$selectedOrganis.organisationId,
        name = _ref2$selectedOrganis.name;
    return _react.default.createElement(_commonReact.RequestProvider, {
      requests: {
        getStoryboards: (0, _api.getStoryboardsApi)(organisationId),
        getArchivedStoryboards: (0, _api.getArchivedStoryboardsApi)(organisationId),
        createStoryboard: (0, _api.createStoryboardApi)(organisationId),
        deleteStoryboard: (0, _api.deleteStoryboardApi)(),
        archiveStoryboard: (0, _api.archiveStoryboardApi)(),
        unarchiveStoryboard: (0, _api.unarchiveStoryboardApi)(),
        duplicateStoryboard: (0, _api.duplicateStoryboardApi)()
      }
    }, function (requests) {
      return _react.default.createElement(_commonReact.UploaderConsumer, null, function (_ref3) {
        var fetchAssetsForResource = _ref3.fetchAssetsForResource;
        return _react.default.createElement(_ListStoryboards.default, (0, _extends2.default)({
          history: history,
          fetchAssetsForResource: fetchAssetsForResource,
          organisationId: organisationId,
          organisationName: name
        }, requests));
      });
    });
  });
}

var _default = (0, _withBasedRouter.default)(_basePath.default, ListStoryboards);

exports.default = _default;